import React from "react";
import ReactionsContainer from "../../modules/OrganizationReactions/containers/ReactionsContainer/ReactionsContainer";

const ReactionsInOrg = () => {
  return <ReactionsContainer />;
};

export default ReactionsInOrg;
